export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "US-Dollar",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Grundlegendes Workspace-Angebot mit intelligenten Features für zeitgemäßes Arbeiten mit SaaS, Webanwendungen und Filesharing-Diensten.</p><p>Einschließlich SSO mit Support für Multi-Faktor-Authentifizierung für alle Anwendungen, Workspace Intelligence mit Microapps, personalisierter Feeds und virtueller Assistenzfunktionen, sowie Citrix Content Collaboration Standard mit unbegrenztem Dateispeicher.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Umfassende Workspace-Lösung für Mitarbeiter, die einen vollständigen digitalen Arbeitsplatz mit granularer Sicherheit, aber keine virtuellen Anwendungen und Desktops benötigen.</p><p>Umfasst alle Funktionen von Workspace Standard sowie erweiterte Sicherheitskontrollen für SaaS und das Internet, einheitliches Endgeräte-Management und Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Umfassende Workspace-Lösung einschließlich Optionen zur hybriden Bereitstellung von Citrix Virtual Apps and Desktops.</p><p>Umfasst alle Funktionen von Workspace Premium sowie eine Cloud-Management-Option für Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Mit Citrix Workspace Essentials schützen kleine und mittelgroße Unternehmen ihre Daten durch einfaches und sicheres Anmelden bei SaaS- und Web-Anwendungen.</p><p>Einschließlich Single Sign-On für SaaS- und Web-Anwendungen mit Multi-Faktor-Authentifizierung für einen noch sichereren Anmeldeprozess, was die Chancen von Kontoübernahmen um 99,9 % reduziert.</p>"
            },
            terms: "* Pro Anwender/Monat",
            btn1: "Funktionsmatrix ansehen"
        },
        features: {
            disclaimer1: "* UVP (USD) im Monatsdurchschnitt, pro Anwender basierend auf 500 Anwendern mit Subscription für 3 Jahre. Die tatsächlichen Preise können abweichen.<br /> Für Citrix Workspace sind Lizenzierungsoptionen ab 25 Anwendern verfügbar.",
            disclaimer2: "** Workspace Premium beinhaltet nicht Workspace Analytics für die lokale Bereitstellung von Citrix Virtual Apps and Desktops."
        },
        calculator: {
            edition: "Edition auswählen",
            title: "Kosten berechnen",
            users: "Benutzer auswählen",
            estCost: "Ihre geschätzten Monatskosten",
            btn1: "Mit einem Experten sprechen",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Lizenzierungsoptionen ab 25 Benutzern verfügbar. Bitte versuchen Sie es noch einmal.",
            lowUserMsg: "Sie haben unter 500 Benutzer? Wir unterstützen die Anforderungen kleiner und mittelgroßer Unternehmen.",
            volumeDiscount: "Mehr als 2.500 Benutzer? Profitieren Sie von Mengenrabatten.",
            contract1: "1-Jahres-Vertrag",
            contract3: "3-Jahres-Vertrag",
            contract3savings: "20 % Einsparungen",
            term: "Pro Anwender/Monat",
            disclaimer: "* Dieser Rechner liefert nur geschätzte Preise und sollte nur zur Budgetplanung verwendet werden. Die tatsächlichen Preise können abweichen. Wenden Sie sich für Rabatte an Ihr Citrix Team oder Ihren Citrix Partner."
        },
        stats: {
            title: "Ihre Vorteile",
            stat1: {
                title: "Bessere Employee Experience",
                desc: "<b>4 von 5</b> IT-Experten sehen die Employee Experience als ausschlaggebend für die digitale Transformation."
            },
            stat2: {
                title: "Mehr Freiheit für Mitarbeiter",
                desc: "<b>78 %</b> aller Geschäftsführer stimmen zu, dass es die Employee Experience verbessert, wenn Mitarbeiter Anwendungen und Endgeräte selbst wählen können."
            },
            stat3: {
                title: "Einfacherer Zugriff",
                desc: "<b>47 %</b> aller Geschäftsführer geben an, dass der größte Beitrag zur Mitarbeitermotivation ein einfacher Zugriff auf die Informationen ist, die sie für ihre Arbeit benötigen."
            },
            btn1: "Mit einem Experten sprechen",
            disclaimer: "Quelle: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}